import { Icon } from "../../atoms";
import styled from "styled-components";

const TransitionWrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100vh;
  /* background-color: ${(theme: any) => theme.theme.Light5}; */
  background-color: #141415;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.8;
`;
export const PageLoader = () => {
  return (
    <TransitionWrapper>
      <Icon name="pageLoader" width="auto" height="auto" />
    </TransitionWrapper>
  );
};
